
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBeaconMinorSpecialPurpose as ObiSimplifiedBeaconMinorSpecialPurposeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-beacon-minor-special-purpose.js';
 
 
 

 
 export const ObiSimplifiedBeaconMinorSpecialPurpose = createComponent({
   react: React,
   tagName: 'obi-simplified-beacon-minor-special-purpose',
   elementClass: ObiSimplifiedBeaconMinorSpecialPurposeElement,
   events: {
     
   }
  });
 
 